import type { CategoryItem } from '@/components/widgets/CategoryWidget/CategoryWidget.types';
import type { WidgetDataMap, WidgetType } from '@/types/widgets';

export const widgetValidator = {
  HOME_PAGE_PRODUCT_LIST: (
    _data: unknown
  ): _data is WidgetDataMap['HOME_PAGE_PRODUCT_LIST'] => true,
  STATIC_SEARCH_BAR: (
    data: unknown
  ): data is WidgetDataMap['STATIC_SEARCH_BAR'] =>
    !!data && typeof data === 'object',
  DIVIDER_WIDGET: (data: unknown): data is WidgetDataMap['DIVIDER_WIDGET'] =>
    !!data && typeof data === 'object',
  CURATION_WIDGET: (data: unknown): data is WidgetDataMap['CURATION_WIDGET'] =>
    !!data &&
    typeof data === 'object' &&
    'title' in data &&
    typeof data.title === 'string' &&
    'curator' in data &&
    typeof data.curator === 'string' &&
    'curatorImage' in data &&
    typeof data.curatorImage === 'string' &&
    'views' in data &&
    typeof data.views === 'string' &&
    'timeSinceCreated' in data &&
    typeof data.timeSinceCreated === 'string' &&
    'ctaUrl' in data &&
    typeof data.ctaUrl === 'string' &&
    'maxThumbnails' in data &&
    typeof data.maxThumbnails === 'number' &&
    'referenceId' in data &&
    typeof data.referenceId === 'number' &&
    'thumbnails' in data &&
    Array.isArray(data.thumbnails) &&
    data.thumbnails.reduce((val, thumbnail) => {
      return (
        val && 'imageUrl' in thumbnail && typeof thumbnail.imageUrl === 'string'
      );
    }, true),
  GENERIC_CTA_WIDGET: (
    data: unknown
  ): data is WidgetDataMap['GENERIC_CTA_WIDGET'] =>
    !!data &&
    typeof data === 'object' &&
    'title' in data &&
    typeof data.title === 'string' &&
    'maxThumbnails' in data &&
    typeof data.maxThumbnails === 'number' &&
    'items' in data &&
    Array.isArray(data.items) &&
    data.items.reduce((val, item) => {
      return (
        val &&
        'image' in item &&
        typeof item.image === 'string' &&
        val &&
        'ctaUrl' in item &&
        typeof item.ctaUrl === 'string' &&
        'rank' in item &&
        typeof item.rank === 'number' &&
        'slug' in item &&
        typeof item.slug == 'string'
      );
    }, true),
  CATEGORY_WIDGET: (data: unknown): data is WidgetDataMap['CATEGORY_WIDGET'] =>
    !!data &&
    typeof data === 'object' &&
    'title' in data &&
    typeof (data as { title: unknown }).title === 'string' &&
    'items' in data &&
    Array.isArray((data as { items: unknown }).items) &&
    ((data as { items: unknown }).items as unknown[][]).every(
      (row: unknown) =>
        Array.isArray(row) &&
        row.every((item: unknown) => {
          const i = item as CategoryItem;
          return (
            !!i &&
            typeof i === 'object' &&
            'id' in i &&
            typeof i.id === 'number' &&
            'type' in i &&
            typeof i.type === 'string' &&
            'title' in i &&
            typeof i.title === 'string' &&
            'imageUrl' in i &&
            typeof i.imageUrl === 'string' &&
            'ctaUrl' in i &&
            typeof i.ctaUrl === 'string'
          );
        })
    ),
} satisfies {
  [K in WidgetType]: (data: unknown) => data is WidgetDataMap[K];
};
